/**
 * Translation helpers for conditional text based on feature flags
 * Handles the "Online Presence" naming variants (Websites / Lead Capture)
 */

import store from '@/store';

export const ONLINE_PRESENCE_NAMING_FF = 'directory.business_administration.online_presence_naming';
export const LEAD_CAPTURE_NAMING_FF = 'pkg.dashboard.leadswidget';

// Ordered by priority: the first enabled flag wins.
const ONLINE_PRESENCE_NAMING_VARIANTS = [
  { featureFlag: LEAD_CAPTURE_NAMING_FF, suffix: '_lead_capture' },
  { featureFlag: ONLINE_PRESENCE_NAMING_FF, suffix: '_websites' },
];

/**
 * Picks a translation key suffix based on the first enabled naming feature flag.
 * @param {String} baseKey - The base translation key without suffix
 * @param {Array<{featureFlag: String, suffix: String}>} variants - Ordered flag→suffix mappings
 * @returns {String} The base key, or the base key with the matched suffix appended
 */
export const getFeatureFlaggedTranslationKey = (baseKey, variants) => {
  const hasFeature = (featureFlag) => store.getters['BusinessStore/hasFeature'](featureFlag);
  const matched = variants.find(({ featureFlag }) => hasFeature(featureFlag));
  return matched ? `${baseKey}${matched.suffix}` : baseKey;
};

/**
 * Gets the appropriate translation key for the "Online Presence" naming variants.
 * Prefers "Lead Capture" naming, then "Websites" naming, then the default.
 * @param {String} baseKey - The base translation key without suffix
 * @returns {String} The appropriate translation key to use
 */
export const getOnlinePresenceTranslationKey = (baseKey) => (
  getFeatureFlaggedTranslationKey(baseKey, ONLINE_PRESENCE_NAMING_VARIANTS)
);

/**
 * Helper to get conditional translation text directly
 * @param {Object} vueInstance - Vue component instance with $t method
 * @param {String} baseKey - The base translation key
 * @returns {String} The translated text
 */
export const getConditionalTranslation = (vueInstance, baseKey) => {
  const key = getOnlinePresenceTranslationKey(baseKey);
  // eslint-disable-next-line
  return vueInstance.$t(key);
};

export default {
  getFeatureFlaggedTranslationKey,
  getOnlinePresenceTranslationKey,
  getConditionalTranslation,
}; 
